import React, { PureComponent } from 'react';
import './OperateContent.scss';

export default class OperateContent extends PureComponent {
  render() {
    const { isShowClose, onClose } = this.props;
    return (
      <div className="sing-operate-content">
        {isShowClose && (
          <span className="icon-close" onClick={onClose}>
            {/* 关闭按钮 */}
          </span>
        )}
      </div>
    );
  }
}

OperateContent.defaultProps = {
  isShowClose: true, // 是否展示关闭按钮
  onBack: () => {}, // 点击返回按钮
};
